import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { AppBar, Typography, useTheme, styled, List, ListItem, ListItemIcon, ListItemText, Button } from '@mui/material';
import { baseColors } from 'utils/constants';
import PolygonIcon from './icons/Polygon';
//import Search from './Search';

// asset
import lineImage from 'assets/images/banner/line-banner.png';
import contactImage from 'assets/images/banner/contact-number.png';
import MypageIcon from './icons/Mypage';
import MenuRentalButton from './MenuRentalButton';
import SmallStarIcon from './icons/SmallStar';
import UnlimitedIcon from 'components/icons/Unlimited';
import UilCalenderIcon from './icons/UilCalender';
import { Link, useNavigate } from 'react-router-dom';

const menuLists = [
  { text: 'ホーム', src: `${process.env.REACT_APP_PUBLIC_URL}` },
  { text: '初めてのWi-Fiレンタル', src: `${process.env.REACT_APP_PUBLIC_URL}/first-time/` },
  { text: '空港受け取り', src: `${process.env.REACT_APP_PUBLIC_URL}/service-campaign/airport/` },
  { text: '入院時の利用', src: `${process.env.REACT_APP_PUBLIC_URL}/hospital/` },
  { text: '店舗受け取り', src: `${process.env.REACT_APP_PUBLIC_URL}/service-campaign/store-receipt/` },
  { text: 'ホテル受け取り', src: `${process.env.REACT_APP_PUBLIC_URL}/service-campaign/hotel/` },
  { text: '法人契約・請求書払', src: `${process.env.REACT_APP_PUBLIC_URL}/service-campaign/corporate-contract/` },
  { text: 'レンタル料金表', src: `${process.env.REACT_APP_PUBLIC_URL}/price-table-2/` },
  { text: 'Wi-Fiレンタルの延長を希望される方へ', src: `${process.env.REACT_APP_PUBLIC_URL}/extension/` },
  { text: 'よくある質問', src: `${process.env.REACT_APP_PUBLIC_URL}/qanda/` },
  // { text: 'Wi-Fiブログ', src: `${process.env.REACT_APP_PUBLIC_URL}` },
  { text: 'お問い合わせ', src: `${process.env.REACT_APP_PUBLIC_URL}/contact_us/` }
];

interface TabPanelProps {
  children?: React.ReactNode;
  dir?: string;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`
  };
}

const MenuTabs = ({ closer }: { closer: () => void }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    navigate('/rental/login');
  };

  const CustomTab = styled(Tab)(({ theme }) => ({
    margin: '0 10px', // タブ間のマージン
    opacity: 1,
    '&.MuiTab-root': {
      // 非アクティブなタブのスタイル
      backgroundColor: baseColors.gray,
      color: baseColors.middleGray,
      fontWeight: '700'
    },
    '&.Mui-selected': {
      // アクティブなタブのスタイル
      backgroundColor: baseColors.red,
      color: baseColors.white,
      fontWeight: '700',
      border: 'none' // ボーダーを無しにする
    },
    '&.Mui-focusVisible': {
      // フォーカスがある際のスタイル
      outline: 'none' // フォーカスのボーダーを無効に
    }
  }));

  return (
    <Box sx={{ bgcolor: 'background.paper', width: '100%' }}>
      <AppBar position="static" sx={{ backgroundColor: baseColors.white, boxShadow: 'none' }}>
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary" // インジケータの色を設定
          textColor="inherit"
          variant="fullWidth"
          aria-label="full width tabs example"
          slotProps={{
            indicator: { sx: { display: 'none' } }
          }}
        >
          <CustomTab label="MENU" {...a11yProps(0)} />
          <CustomTab label="レンタル" {...a11yProps(1)} />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0} dir={theme.direction}>
        <Box sx={{ width: '260px', margin: '10px auto' }}>
          <Button
            sx={{
              width: '100%',
              mx: 'auto',
              my: 0,
              margin: '15px auto',
              padding: '10px 20px 10px 15px',
              textAlign: 'center',
              bgcolor: baseColors.white,
              border: '3px solid',
              borderColor: baseColors.red,
              borderRadius: '10px',
              boxShadow: 0,
              position: 'relative'
            }}
            onClick={handleClick}
          >
            <MypageIcon sx={{ position: 'absolute', left: 20 }} />
            <Typography
              variant="subtitle1"
              sx={{
                color: baseColors.red
              }}
            >
              マイページログイン
            </Typography>
          </Button>
        </Box>
        <List
          sx={{
            flexGrow: 1, // 均等にスペースを埋める
            width: { xs: '100%', sm: 'auto' },
            minWidth: 0 // フレックスアイテムの幅を適切に調整
          }}
        >
          {menuLists.map((item, index) => (
            <ListItem key={index} sx={{ padding: '3px 15px' }}>
              <ListItemIcon sx={{ minWidth: '20px' }}>
                <PolygonIcon style={{ color: baseColors.red, width: '0.85em' }} />
              </ListItemIcon>
              <ListItemText
                primary={
                  <a href={item.src} style={{ textDecoration: 'none', color: 'inherit' }}>
                    {item.text}
                  </a>
                }
              />
            </ListItem>
          ))}
        </List>
        <Box sx={{ margin: '10px auto', padding: '10px 0', textAlign: 'center' }}>
          <Link to="https://lin.ee/vnV5hvI">
            <img src={lineImage} alt="LINEともだち募集中" />
          </Link>
        </Box>
        <Box sx={{ margin: '10px auto', padding: '10px 0', textAlign: 'center' }}>
          <img src={contactImage} alt="お問い合わせ電話番号" />
        </Box>
      </TabPanel>
      <TabPanel value={value} index={1} dir={theme.direction}>
        <MenuRentalButton children={'サクッとプラン'} icon={<SmallStarIcon />} rate={1} color={baseColors.green} closer={closer} />
        <MenuRentalButton children={'たっぷりプラン'} icon={<SmallStarIcon />} rate={2} color={baseColors.green} closer={closer} />
        <MenuRentalButton
          children={'ピッタリプラン'}
          icon={<SmallStarIcon />}
          rate={3}
          color={baseColors.green}
          url="https://www.wifi-tokyo-rentalshop.com/pittariplan/?itm_source=lp&itm_medium=organic&itm_campaign=lp_saide_L"
          closer={closer}
        />
        <MenuRentalButton children={'無制限プラン'} icon={<UnlimitedIcon />} rate={1} color={baseColors.darkBlue} closer={closer} />
        <MenuRentalButton
          children={'レンタル延長'}
          icon={<UilCalenderIcon />}
          rate={1}
          color={baseColors.red}
          url="/rental/mypage/"
          closer={closer}
        />
      </TabPanel>
    </Box>
  );
};

export default MenuTabs;
